import React from 'react';
import { useWindowDimensions, View } from "react-native";
import Colors from '../../styles/colors';
import GameHelper from '../GameHelper';
import StandardText from '../../sharedComponents/standardText/StandardText';
import PlayerBadge from './PlayerBadge';
import CanastasIndicator from "./CanastasIndicator";

const TeamsInfo = ({ game }) => {
    const { width, height } = useWindowDimensions();

    const viewerTeam = GameHelper.getViewerTeam(game);
    const opponentTeam = GameHelper.getOpponentTeam(game);

    const viewerTeamTotalScore = GameHelper.getTeamTotalScore(viewerTeam, true);
    const opponentTeamTotalScore = GameHelper.getTeamTotalScore(opponentTeam, true);

    const viewerTeamScoreDiff = viewerTeamTotalScore - opponentTeamTotalScore;
    const opponentTeamScoreDiff = opponentTeamTotalScore - viewerTeamTotalScore;

    const scoreDiffColor = (scoreDiff) => {
        if (scoreDiff > 0) {
            return Colors.success;
        } else if (scoreDiff < 0) {
            return Colors.error;
        } else {
            return Colors.onBackgroundBorder;
        }
    };

    const scoreDiffText = (scoreDiff) => {
        if (scoreDiff > 0) {
            if (width < 640) {
                return (`(+${scoreDiff})`);
            }
            return `(${scoreDiff} points ahead)`;
        } else if (scoreDiff < 0) {
            if (width < 640) {
                return (`(-${Math.abs(scoreDiff)})`);
            }
            return `(${Math.abs(scoreDiff)} points behind)`;
        } else {
            if (width < 640) {
                return `(tied)`;
            }
            return `(tied with opponent)`;
        }
    };

    const renderTeamInfo = (team, isViewerTeam, scoreDiff) => {
        return (
            <View style={{ flex: 1, alignItems: isViewerTeam ? 'flex-start' : 'flex-end', marginTop: 15 }}>
                <View style={{ alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', ...(team.teamPlayers.length > 1 ? { width: 85 } : {}) }}>
                        {team.teamPlayers.slice().sort((a, b) => a.seat - b.seat).map((player) => (
                            <View key={player.id} style={ownStyles.playerBadge}>
                                <View style={{marginBottom: 0}}>
                                    <StandardText style={{fontSize: 10, textAlign: 'center', color: 'rgba(160, 166, 183, 1)'}}>{player.isNextTurn ? 'NEXT' : ' '}</StandardText>
                                </View>
                                <PlayerBadge player={player} active={player.isCurrentTurn} next={player.isNextTurn} game={game} popupEnabled={true} />
                            </View>
                        ))}
                    </View>

                    <StandardText style={{marginTop: 10, fontSize: 12, color: 'rgba(160, 166, 183, 1)'}}>
                        {team.partialCurrentScore}
                    </StandardText>

                    {game.currentRound > 0 && typeof scoreDiff === 'number' && (
                        <StandardText style={{marginBottom: 2, fontSize: 12, color: scoreDiffColor(scoreDiff)}}>
                            {isViewerTeam ? scoreDiffText(scoreDiff) : "\u00A0"}
                        </StandardText>
                    )}

                    <CanastasIndicator totalPlayers={GameHelper.getAllPlayers(game).length} team={team} gameConfig={game.gameConfig}/>
                </View>
            </View>
        );
    }

    return (
        <View style={{ ...ownStyles.container }}>
            {renderTeamInfo(viewerTeam, true, viewerTeamScoreDiff)}
            <View style={{ flex: 1, alignItems: 'center' }} />
            {renderTeamInfo(opponentTeam, false, opponentTeamScoreDiff)}
        </View>
    );
};

const ownStyles = {
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        paddingLeft: 15,
        paddingRight: 15
    },
    playerBadge: {

    },
    canastasContainer: {
        flexDirection: 'row',
        marginTop: 5,
        marginBottom: 10
    },
    canastaIndicator: {
        width: 5,
        height: 10,
        marginRight: 2,
        borderWidth: 1,
        borderRadius: 0
    },
    unnaturalCanastaIndicator: {
        borderColor: Colors.blackCard,
    },
    naturalCanastaIndicator: {
        borderColor: Colors.redCard,
    },
    unnaturalCanastaIndicatorComplete: {
        backgroundColor: Colors.blackCard
    },
    naturalCanastaIndicatorComplete: {
        backgroundColor: Colors.redCard
    }
};

export default TeamsInfo;
